<crm-multi-select
  [filtersUiVersion]="filtersUiVersion"
  #multiSelectComponent
  [options]="entities"
  [selectedItems]="_selectedEntities"
  (selectedItemsChange)="onSelect($event)"
  (panelShow)="onShowPanel()"
  (onFilter)="search($event.filter)"
  [showToggleAll]="true"
  [virtualScroll]="true"
  [virtualScrollItemSize]="35"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [disabled]="disabled"
  [appendTo]="appendTo"
  [showClear]="showClear"
  [label]="label"
  [placeholder]="placeholder"
  [loading]="selectionLoading"
  filterBy="name,isoCharacter">
  <ng-template
    #selectedItemsTemplate
    let-currencies="items">
    <ng-container *ngFor="let currency of currencies; last as isLast">
      <ng-container *ngIf="toCurrency(currency) as currency">
        <span [innerHTML]="highlightMatchText(currency.name) | safeHtml"></span>
        {{ isLast ? '' : ', ' }}
      </ng-container>
    </ng-container>
  </ng-template>
  <ng-template
    #itemTemplate
    let-currency="item">
    <div *ngIf="toCurrency(currency) as currency">
      <p>
        <span [innerHTML]="highlightMatchText(currency.name) | safeHtml"></span>
      </p>
      <p class="frm-color-green text-sm">{{ currency.isoCharacter }}</p>
    </div>
  </ng-template>

  <ng-template #footerTemplate>
    <crm-spinner
      *ngIf="paginationLoading"
      top=""
      text=""
      [height]="35"
      [width]="35"
      bottom=""></crm-spinner>
  </ng-template>
</crm-multi-select>
